import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSystemHealth from '../../components/system-health/list-system-health.component';

const SystemHealthView = () => {
  const pageTitle = 'Settings / System Health';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSystemHealth />
    </AppLayout>
  );
};

export default SystemHealthView;
